const PROJECT_POLICY = {
  create: "LeninkaArt.Projects.Create",
  moderate: "LeninkaArt.Projects.Moderate",
  evaluate: "LeninkaArt.Projects.Evaluate",
  manageCriteria: "LeninkaArt.Projects.ManageCriteria",
  manageTeam: "LeninkaArt.Projects.ManageTeam",
} as const

const isGranted = (policies: Record<string, boolean> | null, key: string) => Boolean(policies?.[key])

export const canCreateProject = (grantedPolicies: Record<string, boolean> | null) =>
  isGranted(grantedPolicies, PROJECT_POLICY.create)

export const canSeeProjectsModerationNav = (grantedPolicies: Record<string, boolean> | null) =>
  isGranted(grantedPolicies, PROJECT_POLICY.moderate)

export const canSeeProjectRegistry = (grantedPolicies: Record<string, boolean> | null) =>
  canSeeProjectsModerationNav(grantedPolicies)

export const canEvaluateProjects = (grantedPolicies: Record<string, boolean> | null) =>
  isGranted(grantedPolicies, PROJECT_POLICY.evaluate)

export const canManageProjectCriteria = (grantedPolicies: Record<string, boolean> | null) =>
  isGranted(grantedPolicies, PROJECT_POLICY.manageCriteria)

export const canSeeProjectScoreboard = (grantedPolicies: Record<string, boolean> | null) =>
  canSeeProjectsModerationNav(grantedPolicies)

export const canManageProjectTeam = (grantedPolicies: Record<string, boolean> | null) =>
  isGranted(grantedPolicies, PROJECT_POLICY.manageTeam) || canSeeProjectsModerationNav(grantedPolicies)

export type ProjectPortalPermissionArea =
  | "create"
  | "registry"
  | "moderation"
  | "evaluation"
  | "criteria"
  | "scoreboard"
  | "teamInvitations"
  | "team"

export const canAccessProjectPortalArea = (
  area: ProjectPortalPermissionArea,
  grantedPolicies: Record<string, boolean> | null,
) => {
  if (area === "create") return canCreateProject(grantedPolicies)
  if (area === "registry") return canSeeProjectRegistry(grantedPolicies)
  if (area === "moderation") return canSeeProjectsModerationNav(grantedPolicies)
  if (area === "evaluation") return canEvaluateProjects(grantedPolicies)
  if (area === "criteria") return canManageProjectCriteria(grantedPolicies)
  if (area === "scoreboard") return canSeeProjectScoreboard(grantedPolicies)
  if (area === "teamInvitations") return true
  if (area === "team") return canManageProjectTeam(grantedPolicies)
  return false
}
